import { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { tenantActions } from "../../store/tenant/tenant-slice";
import { useGetTenantConfigQuery } from "../../api/tenantConfigApi";
import { useAppSelector, useAppDispatch } from "../../store/hooks";

const AuthContainer = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const dispatch = useAppDispatch();
  const { data } = useGetTenantConfigQuery();
  const isAuthenticated = useAppSelector((state) => state.auth.token);
  const configCarregada = useAppSelector(
    (state) => state.tenantConfiguration.configCarregada,
  );
  const hasApiUrl = localStorage.getItem("apiUrl");

  useEffect(() => {
    if (!configCarregada && data) {
      console.log("[TenantConfig]", data);
      dispatch(tenantActions.setTenantConfig(data));
    }
  }, [configCarregada, data, dispatch]);

  if (!isAuthenticated || !hasApiUrl) {
    localStorage.clear();
    return <Navigate to={"/"} replace />;
  }
  return children;
};

export default AuthContainer;
